import { render, staticRenderFns } from "./PconConfigurator.vue?vue&type=template&id=69d00541&"
import script from "./PconConfigurator.vue?vue&type=script&lang=js&"
export * from "./PconConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/Plenty Update/pp-weberbuero/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69d00541')) {
      api.createRecord('69d00541', component.options)
    } else {
      api.reload('69d00541', component.options)
    }
    module.hot.accept("./PconConfigurator.vue?vue&type=template&id=69d00541&", function () {
      api.rerender('69d00541', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/PconConfigurator.vue"
export default component.exports